export default "__VITE_ASSET__DWYpBkpa__"